LOWER_TIME_BOUND = moment({y: 2000, M: 0, d: 1, h: 0, m: 0, s: 0, ms: 0}).toDate()
UPPER_TIME_BOUND = moment({y: 2000, M: 0, d: 1, h: 23, m: 59, s: 59, ms: 999}).toDate()

App.TimeEditorComponent = Ember.Component.extend
  classNames: ['time-editor-component']

  ###
  # Нижняя граница для возможного для выбора времени
  ###
  lowerTimeBound: Ember.computed(
    'flag',
    'granulation',
    'timetable.open_at',
    'timetable.close_at',
    'day.@each.open_at',
    'day.@each.close_at',
    ->
      flag      = @get 'flag'
      timetable = @get 'timetable'
      day       = @get 'day'

      if flag is 'from'
        previous = day.objectAt(day.indexOf(timetable) - 1)

        unless previous?
          LOWER_TIME_BOUND
        else
          moment(previous.get('close_at'))
            .add(@get('granulation'), 'm')
            .toDate()

      else
        moment(timetable.get('open_at'))
          .add(@get('granulation'), 'm')
          .toDate()
  )

  ###
  # Верхняя граница для возможного для выбора времени
  ###
  upperTimeBound: Ember.computed(
    'flag',
    'granulation',
    'timetable.open_at',
    'timetable.close_at',
    'day.@each.open_at',
    'day.@each.close_at',
    ->
      flag      = @get 'flag'
      timetable = @get 'timetable'
      day       = @get 'day'

      if flag is 'from'
        moment(timetable.get('close_at'))
          .subtract(@get('granulation'), 'm')
          .toDate()

      else
        next = day.objectAt(day.indexOf(timetable) + 1)

        unless next?
          UPPER_TIME_BOUND
        else
          moment(next.get('open_at'))
            .subtract(@get('granulation'), 'm')
            .toDate()
  )
